import { Compass, Fingerprint, Layers, Zap, TrendingUp, Network } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const REASONS = [
  { icon: Compass, title: "Travel-Focused", copy: "Designed around destination commerce workflows — not adapted from generic software." },
  { icon: Fingerprint, title: "White-Label", copy: "Your brand stays front and centre. Your domain, your colours, your customer experience." },
  { icon: Layers, title: "Multi-Tenant", copy: "Built to support multiple businesses independently — each with its own data and brand." },
  { icon: Zap, title: "Fast to Launch", copy: "Configure your business without starting from zero. No developers required." },
  { icon: TrendingUp, title: "Scalable", copy: "Start with one destination and expand across countries as you grow." },
  { icon: Network, title: "Distribution Ready", copy: "Built around B2B, API and partner distribution as your channels expand." },
];

export default function WhyDMCs() {
  return (
    <section id="why" className="border-y border-sand bg-parch py-24 lg:py-32">
      <div className="container-x">
        <Reveal><Chapter index={12} label="Why Travel-Tek" /></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-2xl font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Why Travel-Tek?
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={0.06 * i}>
              <div
                data-testid={`why-card-${r.title.toLowerCase().replace(/\s/g, "-")}`}
                className="group h-full rounded-2xl border border-sand bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-terra/50 hover:shadow-[0_24px_50px_-24px_rgba(196,154,90,0.45)]"
              >
                <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-full bg-parch text-ink transition-colors duration-500 group-hover:bg-terra">
                  <r.icon className="h-5 w-5" />
                </div>
                <h3 className="text-lg font-bold text-ink">{r.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-stone2">{r.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
